/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters with spaces counts every character in your text, including the blank spaces between words. Characters without spaces removes those first. Use the with-spaces count for limits that count spaces too, like SMS (160) or a post on X (280); use the without-spaces count when a system strips whitespace before counting.`)
};

const es_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres con espacios cuenta cada carácter en tu texto, incluidos los espacios en blanco entre palabras. Caracteres sin espacios elimina esos primero. Usa el recuento con espacios para límites que también cuentan espacios, como SMS (160) o una publicación en X (280); usa el recuento sin espacios cuando un sistema elimina espacios en blanco antes de contar.`)
};

const de_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen mit Leerzeichen zählt jedes Zeichen in Ihrem Text, einschließlich der Leerzeichen zwischen Wörtern. Zeichen ohne Leerzeichen entfernt diese zuerst. Verwenden Sie die Zählung mit Leerzeichen für Limits, die Leerzeichen auch zählen, wie SMS (160) oder ein Beitrag auf X (280); verwenden Sie die Zählung ohne Leerzeichen, wenn ein System Leerzeichen vor dem Zählen entfernt.`)
};

const nl_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekens met spaties telt elk teken in uw tekst, inclusief de blanco spaties tussen woorden. Tekens zonder spaties verwijdert deze eerst. Gebruik het aantal met spaties voor limieten die spaties ook tellen, zoals SMS (160) of een bericht op X (280); gebruik het aantal zonder spaties wanneer een systeem witruimte verwijdert voordat het telt.`)
};

const fr_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les caractères avec espaces comptent chaque caractère de votre texte, y compris les espaces vierges entre les mots. Les caractères sans espaces supprime d'abord ceux-ci. Utilisez le nombre avec espaces pour les limites qui comptent aussi les espaces, comme SMS (160) ou un message sur X (280) ; utilisez le nombre sans espaces quand un système supprime l'espace blanc avant de compter.`)
};

const it_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I caratteri con spazi contano ogni carattere nel tuo testo, inclusi gli spazi vuoti tra le parole. I caratteri senza spazi rimuovono prima quelli. Usa il conteggio con spazi per i limiti che contano anche gli spazi, come SMS (160) o un post su X (280); usa il conteggio senza spazi quando un sistema rimuove gli spazi bianchi prima di contare.`)
};

const pt_br2_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres com espaços conta cada caractere em seu texto, incluindo os espaços em branco entre as palavras. Caracteres sem espaços os remove primeiro. Use a contagem com espaços para limites que também contam espaços, como SMS (160) ou uma postagem em X (280); use a contagem sem espaços quando um sistema remove espaços em branco antes de contar.`)
};

const pt_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres com espaços conta cada caracter no seu texto, incluindo os espaços em branco entre palavras. Caracteres sem espaços remove-os primeiro. Utilize a contagem com espaços para limites que contam espaços também, como SMS (160) ou um post em X (280); utilize a contagem sem espaços quando um sistema remove espaços em branco antes de contar.`)
};

const ja_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペース付き文字数は、単語間のスペースを含む、テキスト内のすべての文字をカウントします。スペースなし文字数はそれらを最初に削除します。スペースもカウントする制限にはスペース付き文字数を使用してください。例：SMS（160文字）またはX上の投稿（280文字）。スペースなし文字数は、システムがカウント前に空白を削除する場合に使用してください。`)
};

const zh_wc_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含空格的字符数会统计文本中的每一个字符，包括单词之间的空格。不含空格的字符数会先去除这些空格。对于连空格也计算在内的限制，例如短信（160 字符）或 X 上的一条帖子（280 字符），请使用含空格的字符数；如果某个系统在统计前会先去除空白字符，则使用不含空格的字符数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_faq2_a", locale)
	if (locale === "en") return en_wc_faq2_a(inputs)
	if (locale === "es") return es_wc_faq2_a(inputs)
	if (locale === "de") return de_wc_faq2_a(inputs)
	if (locale === "nl") return nl_wc_faq2_a(inputs)
	if (locale === "fr") return fr_wc_faq2_a(inputs)
	if (locale === "it") return it_wc_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_wc_faq2_a(inputs)
	if (locale === "pt") return pt_wc_faq2_a(inputs)
	if (locale === "ja") return ja_wc_faq2_a(inputs)
	return zh_wc_faq2_a(inputs)
};